module.exports = __webpack_public_path__ + "img/Review1.159077d0.png";